/* Teslong blog — article enhancements (prototype v1.0). No dependencies; everything degrades without JS. */
(function () {
  var root = document.querySelector('[data-tl-article]');
  if (!root) return;

  /* 0. Sticky site header offset -> --tl-top (rail sticky position, anchor offsets) */
  var siteHeader = document.querySelector('.site-header');
  var topOffset = 0;
  function measureTop() {
    var cs = siteHeader ? getComputedStyle(siteHeader) : null;
    topOffset = cs && (cs.position === 'sticky' || cs.position === 'fixed') ? siteHeader.offsetHeight : 0;
    document.documentElement.style.setProperty('--tl-top', topOffset + 'px');
  }
  // the theme makes its header sticky after load, so re-measure on load and while scrolling (cheap: one style read)
  measureTop();
  window.addEventListener('resize', measureTop);
  window.addEventListener('load', measureTop);
  window.addEventListener('scroll', function () { if (!topOffset) measureTop(); }, { passive: true });

  /* 1. TOC highlight (rail): recomputed on scroll, last heading above the reading line wins */
  var links = Array.prototype.slice.call(root.querySelectorAll('.tl-toc a[href^="#"]'));
  var heads = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
  var current = null, locked = null, lockY = 0;
  function setActive(h) {
    if (h === current) return;
    current = h;
    links.forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('href') === '#' + h.id ? 'true' : 'false'); });
    var active = root.querySelector('.tl-toc a[aria-current="true"]');
    var list = active && active.closest('ol');
    if (list && list.scrollHeight > list.clientHeight) list.scrollTop = active.offsetTop - list.offsetTop - list.clientHeight / 2;
  }
  function updToc() {
    if (!heads.length) return;
    // after a TOC click the clicked item stays highlighted, during the scroll and until the reader scrolls on
    if (locked) {
      if (job || Math.abs(window.pageYOffset - lockY) < 40) return;
      locked = null;
    }
    var line = topOffset + window.innerHeight * 0.3, best = heads[0];
    heads.forEach(function (h) { if (h.getBoundingClientRect().top <= line) best = h; });
    // at the very bottom the last headings may never reach the line
    if (window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2) best = heads[heads.length - 1];
    setActive(best);
  }

  /* 1b. TOC click: one smooth scroll, then re-aim only after it has settled (images loading above can push the target).
     Never jump mid-animation: coordinates read during a smooth scroll lag a frame and the jump overshoots. */
  var job = null;
  var STOP_EVENTS = ['wheel', 'touchstart', 'keydown', 'mousedown'];
  function stopJob() { endJob(true); }
  function endJob(release) {
    if (!job) return;
    clearTimeout(job.idle);
    clearTimeout(job.cap);
    window.removeEventListener('scroll', job.onScroll);
    window.removeEventListener('scrollend', job.settle);
    STOP_EVENTS.forEach(function (ev) { window.removeEventListener(ev, stopJob, true); });
    anchoring(true);
    job = null;
    if (release === true) locked = null;
    lockY = window.pageYOffset;
    updToc();
  }
  // lazy images without dimensions that load mid-scroll make scroll anchoring push the page back a frame
  function anchoring(on) {
    document.documentElement.style.overflowAnchor = document.body.style.overflowAnchor = on ? '' : 'none';
  }
  function scrollToHeading(t) {
    endJob(true);
    measureTop();
    anchoring(false);
    var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targetY = function () { return Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - topOffset - 20); };
    var j = job = { fixes: 0 };
    if (heads.indexOf(t) > -1) { locked = t; setActive(t); }
    j.settle = function () {
      if (job !== j) return;
      clearTimeout(j.idle);
      var y = targetY(), maxY = document.documentElement.scrollHeight - window.innerHeight;
      if (Math.abs(window.pageYOffset - Math.min(y, maxY)) > 6 && j.fixes < 2) {
        j.fixes++;
        window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
        j.idle = setTimeout(j.settle, 200);
      } else endJob();
    };
    // settle = 'scrollend', or no scroll event for 200ms where 'scrollend' is unsupported
    j.onScroll = function () { clearTimeout(j.idle); j.idle = setTimeout(j.settle, 200); };
    window.addEventListener('scroll', j.onScroll, { passive: true });
    window.addEventListener('scrollend', j.settle);
    // the reader takes over: stop steering and release the highlight
    STOP_EVENTS.forEach(function (ev) { window.addEventListener(ev, stopJob, true); });
    j.cap = setTimeout(endJob, 4000);
    j.idle = setTimeout(j.settle, 200);
    window.scrollTo({ top: targetY(), behavior: smooth ? 'smooth' : 'auto' });
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    // collapse the mobile TOC first, then measure: collapsing it moves every heading up
    var btn = root.querySelector('.tl-tocm__btn');
    if (btn && a.closest('.tl-tocm')) toggleToc(btn, false);
    scrollToHeading(t);
    history.replaceState(null, '', a.getAttribute('href'));
    track('tl_toc_click', { target: t.id });
  });

  /* 2. Collapsible TOC (< 1024) */
  function toggleToc(btn, open) {
    var list = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (list) list.hidden = !open;
  }
  var tocBtn = root.querySelector('.tl-tocm__btn');
  if (tocBtn) tocBtn.addEventListener('click', function () { toggleToc(tocBtn, tocBtn.getAttribute('aria-expanded') !== 'true'); });

  /* 2b. Reading progress (rail) */
  var bar0 = root.querySelector('.tl-progress span'), pct = root.querySelector('.tl-toc__pct');
  function updProgress() {
    var b = root.querySelector('.tl-body');
    if (!b || !bar0) return;
    var r = b.getBoundingClientRect();
    var p = Math.min(1, Math.max(0, (topOffset + window.innerHeight * 0.3 - r.top) / r.height));
    bar0.style.width = (p * 100).toFixed(1) + '%';
    if (pct) pct.textContent = Math.round(p * 100) + '%';
  }

  /* 3a. Comparison tables: highlight the column marked th[data-pick] */
  Array.prototype.forEach.call(root.querySelectorAll('.tl-table th[data-pick]'), function (th) {
    var idx = Array.prototype.indexOf.call(th.parentNode.children, th);
    var table = th.closest('table');
    th.insertAdjacentHTML('beforeend', '<span class="tl-pick-badge">Our pick</span>');
    Array.prototype.forEach.call(table.rows, function (row) { if (row.cells[idx]) row.cells[idx].classList.add('is-pick'); });
  });

  /* 3. Table overflow hint */
  Array.prototype.forEach.call(root.querySelectorAll('.tl-table'), function (box) {
    var sc = box.querySelector('.tl-table__scroll');
    if (!sc) return;
    function upd() {
      box.classList.toggle('is-overflow', sc.scrollWidth > sc.clientWidth + 2);
      box.classList.toggle('is-end', sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2);
    }
    sc.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });

  /* 4. Sticky buy bar (< 1024): visible after 25% of the article, hidden once the end CTA is reached */
  var bar = root.querySelector('.tl-bar');
  var body = root.querySelector('.tl-body');
  var cta = root.querySelector('.tl-cta');
  var mq = matchMedia('(max-width: 1023px)');
  function updBar() {
    if (!bar || !body) return;
    var on = false;
    if (mq.matches) {
      var r = body.getBoundingClientRect();
      var progress = (window.innerHeight - r.top) / (r.height || 1);
      var ctaTop = cta ? cta.getBoundingClientRect().top : Infinity;
      on = progress > 0.25 && ctaTop > window.innerHeight;
    }
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.body.classList.toggle('tl-bar-on', on);
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; updBar(); updToc(); updProgress(); });
  }, { passive: true });
  window.addEventListener('resize', updBar);
  updBar();
  updToc();
  updProgress();

  /* 5. FAQ + product clicks tracking */
  Array.prototype.forEach.call(root.querySelectorAll('.tl-faq details'), function (d, i) {
    d.addEventListener('toggle', function () { if (d.open) track('tl_faq_open', { index: i + 1 }); });
  });
  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-tl-evt]');
    if (el) track('tl_article_product_click', { position: el.getAttribute('data-tl-evt'), product: el.getAttribute('data-product') || '' });
  });

  /* 6. Video facade */
  Array.prototype.forEach.call(root.querySelectorAll('.tl-video[data-yt]'), function (v) {
    var id = v.getAttribute('data-yt');
    v.style.backgroundImage = 'url(https://i.ytimg.com/vi/' + id + '/hqdefault.jpg)';
    v.innerHTML = '<button type="button" aria-label="Play video: ' + (v.getAttribute('data-title') || '') + '"></button>';
    v.addEventListener('click', function () {
      v.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="' + (v.getAttribute('data-title') || 'Video') + '"></iframe>';
    }, { once: true });
  });

  function track(name, params) {
    try { if (window.gtag) window.gtag('event', name, params); else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
  }
})();
